import { MAPLIBRE_MARKER_SELECTOR } from "./maplibre-marker.constants";

/**
 * Whether the pointer is over an HTML marker rather than the map canvas.
 *
 * MapLibre's layer-scoped `mousemove` is delegated from the canvas container, and markers are DOM children
 * of that container — so moving over a marker still bubbles up and `queryRenderedFeatures` happily reports
 * whatever layer is drawn *underneath* it. A marker occludes the layer, so a hover on the marker is not a
 * hover on the layer, and consumers use this to ignore it.
 */
export const isPointerOverMapLibreMarker = (event: {
  originalEvent?: { target?: EventTarget | null } | null;
}): boolean => {
  const target = event.originalEvent?.target as HTMLElement | null;

  return !!target?.closest?.(MAPLIBRE_MARKER_SELECTOR);
};
